import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import uniq from 'lodash/uniq';
import cloneDeep from 'lodash/cloneDeep';
import omit from 'lodash/omit';
import omitBy from 'lodash/omitBy';
import globalEvents from '@/utils/globalEvents';
import { findValuesByKey, getObjectDiff } from '@/utils/objects'; // Opens the theme editor modal

export function triggerEditTheme(ctx) {
  globalEvents.trigger('themeEdit', {
    detail: ctx
  });
} // Removes all customizations for the specified element

export function resetElementCustomization(customizations, elementGroup, element, themeMode) {
  var _cloneDeep;

  let newCustomizations = ((_cloneDeep = cloneDeep(customizations)) === null || _cloneDeep === void 0 ? void 0 : _cloneDeep[themeMode]) || {};
  const elementKey = `${elementGroup}.${element}`;
  newCustomizations = omitBy(newCustomizations, (_, key) => {
    return key.startsWith(`${elementKey}.`) || key === elementKey;
  });
  return _objectSpread(_objectSpread({}, customizations), {}, {
    [themeMode]: newCustomizations
  });
} // Extracts the first font name from a font family string

function extractFirstFontName(fontFamily) {
  return fontFamily.split(',')[0].trim().replace(/^['"]|['"]$/g, '');
} // Combines font families and weights into FontToVariant array
// from the theme settings


export function getFontVariants(settings) {
  // Get unique font families for regular and mono
  const fontFamilies = uniq(findValuesByKey(settings, ['fontFamily', 'fontFamilyMono']).map(font => extractFirstFontName(font))); // Get unique font weights

  const fontWeights = uniq(findValuesByKey(settings, ['fontWeight'])); // Create FontToVariant array

  return fontFamilies.map(fontName => ({
    fontName,
    variants: fontWeights.map(weight => ({
      italic: false,
      weight
    }))
  }));
} // Normalizes theme customization variants to ensure proper inheritance and diff display.

export const normalizeCustomizationVariants = customizations => {
  var _customizations$varia;

  const darkCustomizationVariant = ((_customizations$varia = customizations.variants) === null || _customizations$varia === void 0 ? void 0 : _customizations$varia.dark) || {}; // compute the actual diff between dark variant and base theme

  let darkVariantDiff = getObjectDiff(darkCustomizationVariant, omit(customizations, 'variants'), true);
  darkVariantDiff = omit(darkVariantDiff, ['base', 'spacing']); // return normalized customizations with only the meaningful differences in dark variant

  return Object.assign({}, customizations, {
    variants: {
      dark: darkVariantDiff
    }
  });
};